import { merge } from 'lodash';
const NO_TRANSPORT_VALUE = 'NO';
export type ProductBookingDescriptorProps = {
  checkPriceLabel: string;
  enableTransfer: boolean;
  minAgeErrorMessage: string;
  minAgeInformation: string;
  package: {
    errorMessageNoMorePackages: string;
    errorMessageNoProposal: string;
  };
  resortId: string;
};
export type ProductBookingGQLProps = {
  bookingCriteria: {
    departureCities: Array<{
      value: string;
      name: string;
    }>;
    durations: Array<number>;
    initialTransport: number;
    initialDuration: number;
    initialNumberOfAdults: number;
    initialNumberOfChildren: number;
  };
  config: CMSContent;
  legalInformations: {
    bookingProcess: Array<{
      id: string;
      description: string;
    }>;
  };
  resort: null | Partial<Product>;
};
export type ProductBookingLineProps = ProductBookingDescriptorProps & ProductBookingGQLProps;
export const getBookingConfig = (props: ProductBookingLineProps) => {
  const {
    checkPriceLabel,
    config,
    enableTransfer,
    minAgeErrorMessage,
    minAgeInformation,
    package: bookingPackage,
    resortId,
  } = props;
  return {
    ...config,
    booking: merge(config.booking, {
      checkPriceLabel,
      departureCity: NO_TRANSPORT_VALUE,
      enableTransfer,
      minAgeErrorMessage,
      minAgeInformation,
      package: bookingPackage,
      resortId,
    }),
  };
};
